export default __webpack_public_path__ + "static/media/slide5.3321ae52.jpg";